export default {
  name: 'chat-field',
  props: {
    sendAction: Function,
    providerName: String,
  },
  data() {
    return {
      isLoading: false,
      showError: false,
      messageContent: '',
    };
  },
  computed: {
    extraClass() {
      return {
        'chat-field--loading': this.isLoading,
      };
    },
  },

  methods: {
    submit() {
      if (this.isLoading) {
        return false;
      }

      this.isLoading = true;
      this.showError = false;

      return this.sendAction(this.messageContent)
        .then(() => {
          this.messageContent = '';
        })
        .catch(() => {
          this.showError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
